import { fromDatetimeInputToISO } from '@/common/utils/date/fromDatetimeInputToISO.util';
import { isValid } from '@/common/utils/validation/common.utils';
import { BranchResponse } from '@/core/domain/branches/models/branch-response.model';
import { BranchParams } from '@/core/domain/branches/models/branch.model';
import { BranchesRepository } from '@/core/domain/branches/repositories/branches.repository';
import { updateReservation } from '@/core/reservation/store/reservation.actions';
import { environment } from '@/env/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BranchesImplRepository extends BranchesRepository {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly store: Store,
    ) {
        super();
    }

    override findBranches(
        BranchInfo: BranchParams,
    ): Observable<BranchResponse> {
        let params = new HttpParams();
        if (isValid(BranchInfo.cupon)) {
            params = params.append('coupon', BranchInfo.cupon);
        } else {
            this.store.dispatch(
                updateReservation({
                    value: {
                        discountCode: '',
                    },
                }),
            );
        }
        if (BranchInfo.id_sucursal_devolucion) {
            params = params.append(
                'returnBranchId',
                BranchInfo.id_sucursal_devolucion,
            );
        }
        return this.httpClient
            .get(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.searchAvailability,
                    BranchInfo.id_sucursal_renta,
                    fromDatetimeInputToISO(
                        BranchInfo.fRenta,
                        BranchInfo.hRenta,
                    ),
                    fromDatetimeInputToISO(
                        BranchInfo.fDevolucion,
                        BranchInfo.hDevolucion,
                    ),
                    'availability',
                ].join('/'),
                {
                    params: params,
                },
            )
            .pipe(
                switchMap((branchesResponse: BranchResponse) => {
                    const branchs: BranchResponse = {
                        action: _.get(
                            branchesResponse,
                            'action',
                            'CONTINUE_SELECT_BRANCHS',
                        ),
                        type: _.get(branchesResponse, 'type', 'ERROR'),
                        data: branchesResponse.data,
                    };

                    return of(branchs);
                }),
            );
    }
}
